import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { FadeAnimation } from '@app/core/animations/fade.transition';
import { TranslatePipe } from '@ngx-translate/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'adspt-spinner-overlay',
  templateUrl: 'spinner-overlay.component.html',
  styleUrls: ['spinner-overlay.component.scss'],
  imports: [NzSpinModule, TranslatePipe],
  animations: [FadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerOverlayComponent {
  readonly active = input<boolean>(undefined);

  readonly showTip = input(true);

  readonly minHeight = input<number>(undefined);

  @HostBinding('style.min-height.px')
  get minHeightHost(): number | void {
    return this.active() ? this.minHeight() : null;
  }
}
